import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { Table, Button, Icon, Input } from 'semantic-ui-react';
import { getDishes } from '../../../actions/dishes';
import debounce from '../../../utils/debounce';
import { openRecipeModal } from '../../../actions/recipeModal';
import { MEAL_TYPES_DICTIONARY } from '../../../constants/appConstants';
import { filterDish } from '../../../actions/dishSearch';

const DishRow = React.memo(
  ({
    dishId,
    dishes,
    calories,
    carbohydrates,
    fats,
    proteins,
    dishData,
    quantity,
    time,
    recipe,
    openRecipeModal,
    changeDishPortion,
    getDishes,
    changeDish,
    deleteDish,
    changeDishTime,
    type,
    filterDish,
    unwantedFood,
  }) => {
    const [isLoadDishes, setIsLoadDishes] = useState(false);

    useEffect(() => {
      setIsLoadDishes(false);
    }, [dishes]);
    const handleRecommendedSearchDish = () => {
      setIsLoadDishes(true);
      filterDish('', [MEAL_TYPES_DICTIONARY[type].tag_id]);
    };
    const handleSearchDish = (value) => {
      setIsLoadDishes(true);
      getDishes(value);
    };

    let clearable = false;
    let unsuitableDish = false;

    if (dishData && dishData.name) {
      clearable = true;
      unsuitableDish = unwantedFood.some((unwantedDish) => unwantedDish.id === dishData.id);
    }

    const classNameHeadCell = unsuitableDish ? 'menu-table-red-head' : '';
    return (
      <Table.Row className={classNameHeadCell}>
        <Table.Cell className="choose-dish-cell" textAlign="center">
          <Select
            options={dishes}
            simpleValue
            name="select-dish"
            value={dishData}
            onChange={(newDishId) => changeDish(dishId, newDishId, type)}
            onInputChange={debounce(handleSearchDish, 500)}
            onFocus={debounce(handleRecommendedSearchDish, 500)}
            isLoading={isLoadDishes}
            searchable
            clearable={clearable}
            labelKey="name"
            valueKey="id"
            className="select-dish"
          />
          {!!recipe && !!recipe.text && dishData && (
            <Button
              icon
              onClick={() => {
                openRecipeModal({
                  name: dishData.name,
                  image: dishData.image,
                  tags: dishData.tags,
                  ...recipe,
                });
              }}
              style={{ marginLeft: 10 }}
            >
              <Icon name="eye" />
            </Button>
          )}
        </Table.Cell>
        <Table.Cell textAlign="center">{calories}</Table.Cell>
        <Table.Cell textAlign="center">{proteins}</Table.Cell>
        <Table.Cell textAlign="center">{fats}</Table.Cell>
        <Table.Cell textAlign="center">{carbohydrates}</Table.Cell>
        <Table.Cell textAlign="center">
          <Input
            value={quantity}
            placeholder="Порция"
            type="number"
            fluid
            onChange={(e, data) => changeDishPortion(dishId, data.value)}
          />
        </Table.Cell>
        <Table.Cell textAlign="center">
          {time !== null && (
            <Input
              value={time}
              onChange={(e, data) => changeDishTime(dishId, data.value)}
              placeholder="Время приема"
              fluid
            />
          )}
        </Table.Cell>
        <Table.Cell textAlign="center">
          <Button onClick={() => deleteDish(dishId)} color="red" icon>
            <Icon name="delete" />
          </Button>
        </Table.Cell>
      </Table.Row>
    );
  },
);

const mapStateToProps = (state) => ({
  dishes: state.reducers.dishes,
  templateTagsFilters: state.templateGenerator.templateTagsFilters,
  unwantedFood: state.menu.unwantedFood,
});

const mapDispatchToProps = (dispatch) => ({
  openRecipeModal: (recipeModalData) => dispatch(openRecipeModal(recipeModalData)),
  getDishes: (searchName) => dispatch(getDishes(searchName)),
  filterDish: (value, tag_id) => dispatch(filterDish(value, tag_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DishRow);



// WEBPACK FOOTER //
// ./src/Components/Common/MenuBlock/DishRow.jsx